import PaymentDetails from "./PaymentDetails"
import OtherDetails from "./OtherDetails"

export const formSteps={
    1:PaymentDetails,
    2:OtherDetails
}